<template>
  <div>
    <v-dialog v-model="dialog" persistent color="white" width="600px">
      <!--HACK: v-if="dialog" is here for triggering component reload-->
      <document-add-edit-form
        v-if="dialog"
        :dialog-layout="true"
      ></document-add-edit-form>
    </v-dialog>
  </div>
</template>

<script>
import DocumentAddEditForm from "@/components/documents/DocumentAddEditForm";
import { mapGetters } from "vuex";
export default {
  components: {
    DocumentAddEditForm,
  },
  computed: {
    dialog: {
      get: function () {
        return this.getDocumentDialogStatus ? true : false;
      },
    },
    ...mapGetters(["getDocumentDialogStatus"]),
  },
};
</script>

<style></style>
